import CitySEOHead from "@/components/feature/CitySEOHead";
import MandevilleHeroSection from "./components/HeroSection";
import MandevilleStickyNav from "./components/StickyNav";
import MandevilleProcessingTimeSection from "./components/ProcessingTimeSection";
import MandevilleServicesSection from "./components/ServicesSection";
import MandevilleLocalAreaSection from "./components/LocalAreaSection";
import MandevilleTestimonialsSection from "./components/TestimonialsSection";
import MandevilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MandevilleComparisonSection from "./components/ComparisonSection";
import MandevilleMistakesSection from "./components/MistakesSection";
import MandevilleHowItWorksSection from "./components/HowItWorksSection";
import MandevilleFAQSection, { faqs } from "./components/FAQSection";
import MandevilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MandevilleFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import MandevilleTravelTimingSection from "./components/TravelTimingSection";
import MandevilleDestinationsSection from "./components/DestinationsSection";

export default function MandevillePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Mandeville"
        state="Louisiana"
        stateAbbr="LA"
        route="/cities/mandeville"
        title="Emergency Passport Mandeville, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Mandeville, LA — as fast as 24 hours. Serving Northshore professionals, lakefront families, and St. Tammany Parish retirees. No Causeway required. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Mandeville, Louisiana"
        geoPosition="30.3577;-90.0843"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <MandevilleHeroSection />
      <MandevilleStickyNav />
      <MandevilleProcessingTimeSection />
      <MandevilleServicesSection />
      <MandevilleLocalAreaSection />
      <MandevilleTravelTimingSection />
      <MandevilleDestinationsSection />
      <MandevilleTestimonialsSection />
      <MandevilleAcceptanceFacilitiesSection />
      <MandevilleComparisonSection />
      <MandevilleMistakesSection />
      <MandevilleHowItWorksSection />
      <MandevilleFAQSection />
      <MandevilleHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/mandeville" state="LA" />
      <MandevilleFinalCTA />
    </div>
  );
}